<div class="wrapper">
  <h3>{{ name | translate }}</h3>
  @if (isLoading()) {
    <ngx-skeleton-loader
      class="skeleton"
      [theme]="{ width: '100%', height: '100%', background: 'var(--alt-bg2)', opacity: 0.25 }"
    ></ngx-skeleton-loader>
  } @else {
    <div class="chart">
      <canvas
        baseChart
        type="line"
        [data]="chartData()"
        [options]="chartOptions()"
      ></canvas>
    </div>
  }
</div>
